/**
 * Transforms an array of items with language property into a language-keyed object
 * @param items - Array of items with language property
 * @param fieldKey - The key of the field to extract from each item
 * @param defaultLanguage - Default language code to use for empty default value
 * @returns Object with language codes as keys and field values as values
 */
export function reduceByLanguage<T extends { language: string }>(
  items: T[] | undefined,
  fieldKey: keyof T,
  defaultLanguage: string,
): Record<string, string> {
  if (!items) {
    return { [defaultLanguage]: '' };
  }
  return items.reduce(
    (acc, item) => ({ ...acc, [item.language]: item[fieldKey] }),
    {},
  );
}
